<template>
  <div>
    <h3 class="header-title">Find Tutor</h3>
    <label>Let’s see your Find Tutor.</label>

    <br />

    <div v-if="Busy == true">
      <CCol sm="12" md="12">
        <div class="app flex-row align-items-center">
          <div class="container d-flex justify-content-center">
            <PulseLoader float />
          </div>
        </div>
      </CCol>
    </div>

    <div v-else>
      <CCol sm="12" class="mt-4">
        <CRow>
          <!-- search -->
          <CCol sm="12">
            <CRow>
              <CCol sm="3">
                <CInput
                  type="text"
                  placeholder="Search...."
                  v-model.lazy="SearchQuery"
                />
              </CCol>
            </CRow>
          </CCol>

          <!-- add subject & grade -->
          <CCol sm="12">
            <div style="float: right">
              <CButton 
                class="custom-btn-success ml-2" 
                type="button" 
                @click="OpenFormSubject()"
              >
                <CIcon name="cil-plus" />Add subject
              </CButton>

              <CButton
                class="custom-btn-success ml-2"
                type="button"
                @click="OpenFormExam()"
              >
                <CIcon name="cil-plus" />Add Exam
              </CButton>

              <CButton
                class="custom-btn-lgt ml-2"
                type="button"
                @click="OpenFormGrade()"
              >
                <CIcon name="cil-plus" />Find Tutor
              </CButton>
            </div>
          </CCol>
        </CRow>
      </CCol>

      <br />

      <CCol sm="12">
        <div>
          <CRow>
            <CCol sm="4"> </CCol>
            <CCol sm="4"></CCol>
            <CCol sm="4"></CCol>
          </CRow>
        </div>

        <!-- <div style="overflow-x: inherit;"> -->
          <CDataTable
            :hover="hover"
            :striped="striped"
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            :items="ftlist"
            :fields="fields"
            items-per-page-select
            :items-per-page="small ? 5 : 10"
            :dark="dark"
            tableFilter
            pagination
          >
            <template #StudentInfo="{ item }">
              <td>
                <h6 style="color: #1e109c" class="text-uppercase">
                  Student Id : {{ item.StudentId }}
                </h6>
                <div>
                  <span class="custom-small text-muted">
                    Subject Id :</span
                  >
                  <span
                    class="custom-small-overview custom-text-overview"
                    >{{ item.SubjectId }}</span
                  >
                </div>
                <div>
                  <span class="custom-small text-muted"> Subject :</span>
                  <span
                    class="custom-small-overview custom-text-overview"
                    >{{ item.Subject }}</span
                  >
                </div>
                <div>
                  <span class="custom-small text-muted"> Grade :</span>
                  <span
                    class="custom-small-overview custom-text-overview"
                    >{{ item.Grade }}</span
                  >
                </div>
              </td>
            </template>
            <template #ParentInfo="{ item }">
              <td>
                <div>
                  <span class="custom-small text-muted">
                    Parent Name :</span
                  >
                  <span
                    class="custom-small-overview custom-text-overview"
                    >{{ item.ParentName }}</span
                  >
                </div>
                <div>
                  <span class="custom-small text-muted">
                    Parent Number :</span
                  >
                  <span
                    class="custom-small-overview custom-text-overview"
                    >{{ item.ParentNumber }}</span
                  >
                </div>
              </td>
            </template>
            <template #Createdtime="{ item }">
              <td>
                <CBadge color="success" class="ml-auto">{{
                  item.Createdtime | moment("DD MMM YYYY")
                }}</CBadge>
              </td>
            </template>
          </CDataTable>
        <!-- </div> -->
      </CCol>

      <!-- Modal Add Subject -->
      <CModal
        title="Add New Subject"
        size="md"
        :show.sync="SubjectModal"
        :close-on-backdrop="false"
        :close-on-esc="false"
      >
        <div>
          <h6><strong>FORM SUBJECT</strong></h6>

          <br />

          <CCol sm="12">
            <CRow>
              <CCol sm="4"> Subject name </CCol>
              <CCol sm="8">
                <v-select
                  v-model="selectedSubject"
                  :options="subjects"
                  label="SubjectName"
                  placeholder="--Please Select Subject--"
                ></v-select>
              </CCol>

              <br />

              <CButton
                class="p-2"
                color="success"
                @click="AddNewSubject()"
                >
                  Add New Subject
              </CButton>
              <br />

            </CRow>

            <br />

            <CRow v-if="FormNewSubject == true">
              <CCol sm="4"> Subject name </CCol>
              <CCol sm="8">
                <CInput type="text" v-model="selectedSubject" />
              </CCol>

              <br />

              <CCol sm="4"> Short Name </CCol>
              <CCol sm="8">
                <CInput type="text" v-model="ShortName" />
              </CCol>
            </CRow>
          </CCol>

        </div>

        <template #footer>
          <CButton
            type="submit"
            class="p-2"
            color="info"
            @click="SubmitSubject()"
            >
              {{ lblBtn }}
          </CButton>
        </template>
      </CModal>

      <!-- Modal Add Exam -->
      <CModal
        title="Add Exam"
        size="md"
        :show.sync="ExamModal"
        :close-on-backdrop="false"
        :close-on-esc="false"
      >
        <div>
          <h6><strong>FORM EXAM</strong></h6>

          <br />

          <CCol sm="12">
            <CRow>
              <CCol sm="4"> Exam name </CCol>
              <CCol sm="8">
                <CInput type="text" v-model="Name" />
              </CCol>

              <br />

              <CCol sm="4"> Short Name </CCol>
              <CCol sm="8">
                <CInput type="text" v-model="ShortName" />
              </CCol>
            </CRow>
          </CCol>
        </div>

        <template #footer>
          <CButton
            type="submit"
            class="p-2"
            color="info"
            @click="SubmitExam()"
            >
              {{ lblBtn }}
          </CButton>
        </template>
      </CModal>

      
      <!-- Modal Edit Subject -->
      <CModal
        title="Edit Subject"
        size="md"
        :show.sync="EditSubjectModal"
        :close-on-backdrop="false"
        :close-on-esc="false"
      >
        <div>
          <h6><strong>DETAIL SUBJECT</strong></h6>
          <br />
          <CCol sm="12">
            <CRow>
              <CCol sm="5">Subject name</CCol>
              <CCol sm="7">
                <CInput type="text" v-model="SubjectNames" />
              </CCol>
              <CCol sm="5"> Grade Name </CCol>
              <CCol sm="7">
                <v-select
                  v-model="SelectedGradeNames"
                  :options="gradesName"
                  label="Name"
                  placeholder="--Please Select Grade--"
                ></v-select>
                <br />
              </CCol>

              <CCol sm="5"> Class name </CCol>
              <CCol sm="7">
                <v-select
                  v-model="SelectedClassNames"
                  :options="classes"
                  label="Name"
                  placeholder="Please Select Class"
                >
                </v-select>
                <br />
              </CCol>
              <CCol sm="5"> Student Rate (per Month) or (per Hour) </CCol>
              <CCol sm="7">
                <CInput type="number" v-model="StudentFees" />
              </CCol>

              <CCol sm="8" class="mt-4 mb-3">
                <h6>
                  <strong>DETAIL RATE TEACHER</strong>
                </h6></CCol
              >
              <CCol sm="4" class="mt-4 mb-3">
                <CButton
                  class="button mr-2 mt-2 btn-success"
                  @click="AddHourRate"
                  size="sm"
                >
                  <CIcon name="cil-plus" /> Add New Rate
                </CButton></CCol
              >
              <br />
              <table class="table">
                <thead>
                  <th>Hour</th>
                  <th>Rate</th>
                  <th></th>
                </thead>
                <tbody>
                  <tr v-for="item in teacherRate" v-bind:key="item.Id">
                    <td>{{ item.Hour }}</td>
                    <td>{{ item.Rate }}</td>
                    <td>
                      <CButton
                        type="button"
                        class="btn-danger"
                        @click="OpenDeleteTeacherRate(item)"
                        >X Delete</CButton
                      >
                    </td>
                  </tr>
                  <tr
                    v-for="(item, index) in teacherRates"
                    v-bind:key="item.Id"
                  >
                    <td><CInput type="text" v-model="item.Hours" /></td>
                    <td><CInput type="text" v-model="item.Rate" /></td>
                    <td>
                      <button
                        type="button"
                        class="text-center button btn-xs btn-danger"
                        v-on:click="removeRow(index)"
                      >
                        -
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </CRow>
          </CCol>
        </div>
        <template #footer>
          <CButton
            type="submit"
            class="p-2"
            color="info"
            @click="UpdateSubject(SubjectId)"
            >{{ lblSubject }}</CButton
          ></template
        >
      </CModal>
    </div>

      <!-- Modal Delete Subject -->
      <CModal 
        size="md" 
        :show.sync="DeleteSubject"
        :close-on-backdrop="false"
        :close-on-esc="false"
      >
        <div class="text-center">
          <h3 class="custom-title-popup" style="color: #000a2c">
            Delete Subject
          </h3>
          <br />
        </div>
        <div class="text-center">
          <h4 class="sub-title-header" style="color: #000a2c">
            Are you sure you want to delete the<br />
            subject?
          </h4>
          <br />
        </div>
        <template #footer>
          <div class="text-center">
            <CButton
              type="submit"
              size="lg"
              color="info"
              @click="DeleteSubjects()"
              >Yes, sure.</CButton
            >
          </div>
        </template>
      </CModal>

  </div>
</template>


<script>
import _ from "lodash";
import Vue from "vue";
import $ from "jquery";
Vue.use(require("vue-moment"));
import moment from "moment";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import vSelect from "vue-select";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

Vue.use(VuejsDialog);
import jQuery from "jquery";

export default {
  components: {
    PulseLoader,
  },
  data() {
    return {
      subjects: [],
      SearchQuery: "",
      FilteredSubjects: [],
      ftlist: [],

      selectedGrade: "ALL GRADE",
      gradeOptions: [],

      selectedClass: "ALL CLASS",
      classOptions: [],

      perPage: 10,
      pagination: {},
      currentPage: 1,
      DeleteSubject: false,

      Busy: false,
      headers: [
        { text: "Name", value: "name" },
        { text: "Address", value: "address" },
        { text: "Height", value: "height", sortable: true },
        { text: "Weight", value: "weight", sortable: true },
        { text: "Age", value: "age", sortable: true },
        { text: "Favourite sport", value: "favouriteSport" },
        { text: "Favourite fruits", value: "favouriteFruits" },
      ],

      fields: [
        { key: "FindTutorId" },
        { key: "StudentInfo" },
        { key: "ParentInfo" },
        { key: "Content" },
        { key: "IsGroup" },
        { key: "Createdtime" },
      ],

      fieldGradeClass: [
        { key: "Grade" },
        { key: "ClassName" },
        { key: "Action" },
      ],

      fieldReport: [{ key: "Name" }, { key: "Test" }],
      fieldTeachers: [{ key: "Name" }, { key: "Action" }],

      fieldWeekly: [
        { key: "StartDate" },
        { key: "EndDate" },
        { key: "Day" },
        { key: "ScheduleTime" },
        { key: "ScheduleTimeEnd" },
      ],

      FormSubject: false,
      FormGrade: false,
      FormSchedule: false,
      FormReport: false,

      UpdateFormSubject: false,

      gradesName: [],
      classes: [],

      Name: "",
      ShortName: "",
      selectedSubject: "",
      selectedGradeName: "",
      selectedClassName: "",
      StudentFee: "",

      teacherRates: [],

      Hours: "",
      Rate: "",

      small: "",
      fixed: "",

      GradeTc: "",
      ClassTc: "",

      subjectsSchedule: {},

      options: [
        {
          Id: 1,
          dayName: "Monday",
        },
        {
          Id: 2,
          dayName: "Tuesday",
        },
        {
          Id: 3,
          dayName: "Wednesday",
        },
        {
          Id: 4,
          dayName: "Thursday",
        },
        {
          Id: 5,
          dayName: "Friday",
        },
        {
          Id: 6,
          dayName: "Saturday",
        },
        {
          Id: 7,
          dayName: "Sunday",
        },
      ],

      selectedColor: "",
      optionsColor: [
        {
          Id: 1,
          Name: "blue",
        },
        {
          Id: 2,
          Name: "red",
        },
        {
          Id: 3,
          Name: "green",
        },
        {
          Id: 4,
          Name: "purple",
        },
        {
          Id: 5,
          Name: "violet",
        },
      ],
      StartDate: "",
      EndDate: "",
      selectedDay: "",
      ScheduleTime: "",
      ScheduleTimeEnd: "",

      weeklySchedule: [],

      EditSchedule: false,

      subjectsDetails: {},
      students: [],
      selectedStudents: "",
      MonthName: "",
      TestName: "",
      Score: "",

      gradesTc: [],
      FilteredGradeClass: [],
      teachers: [],
      selectedTeacher: "",
      FormAssignTeacher: false,
      teacherList: [],

      subjectsData: [],
      FilteredTeacherList: [],

      FilteredReportCard: [],
      updateReportCard: false,
      MonthNames: "",
      TestNames: "",
      Scores: "",

      FilterWeeklySchedule: [],

      gridData: [
        {
          name: "Chuck Norris",
          power: Infinity,
        },
        {
          name: "Bruce Lee",
          power: 9000,
        },
        {
          name: "Jackie Chan",
          power: 7000,
        },
        {
          name: "Jet Li",
          power: 8000,
        },
      ],

      ScheduleModal: false,
      ScheduleDateTime: "",
      ScheduleDateTimeEnd: "",
      interval: 0,
      selectedTeachers: "",

      ReportModal: false,

      AssignTeacherModal: false,

      SubjectNames: "",
      selectedGradeNames: "",
      selectedClassNames: "",
      StudentFees: "",

      EditSubjectModal: false,

      SelectedGradeNames: {},
      SelectedClassNames: {},

      teacherRate: [],

      SubjectModal: false,
      ExamModal: false,
      GradeModal: false,
      SearchQueryTeacher: "",


      lblBtn: "Proceed",
      lblBtnGrade: "Proceed",
      lblBtnSchedule: "Proceed",
      lblAssign: "Assign Teacher",
      lblSubject: "Proceed",

      SelectedSubjectNames: {},
      subjectsDataSchedule: [],

      ScheduleDateTimes: "",
      ScheduleDateTimeEnds: "",
      intervals: 1,

      FormNewSubject: false,

      user: {},
      currentDate: new Date().toISOString().substring(0, 10),
    };
  },
  async mounted() {
    this.SessionUserIdNo();
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetSubject();
      this.GetClass();
      this.GetGrade();
      this.GetSubjectList();
      this.GetFindTutor();
    } else {
      this.GoToLogin();
    }
  },
  computed: {
    FilteredSubjectsList() {
      if (this.SearchQuery === "") return this.FilteredSubjects;
      return this.FilteredSubjects.filter((item) => {
        //teacher name
        for (const { Name } of item.Teachers) {
          if (Name.toLowerCase().indexOf(this.SearchQuery.toLowerCase()) > -1) {
            return item;
          }
        }

        //teacher rate
        for (const { Hour, Rate } of item.RateTeacher) {
          if (
            Hour.toString().indexOf(this.SearchQuery.toString()) > -1 ||
            Rate.toString().indexOf(this.SearchQuery.toString()) > -1
          ) {
            return item;
          }
        }

        //schedule
        for (const { ScheduleTime, ScheduleTimeEnd } of item.WeeklySchedules) {
          if (
            ScheduleTime.toString().indexOf(this.SearchQuery.toString()) > -1 ||
            ScheduleTimeEnd.toString().indexOf(this.SearchQuery.toString()) > -1
          ) {
            return item;
          }
        }

        //subject name
        if (
          item.SubjectName.toLowerCase().indexOf(
            this.SearchQuery.toLowerCase()
          ) > -1
        ) {
          return item;
        }

        //Grade name
        if (
          item.Grade.toLowerCase().indexOf(this.SearchQuery.toLowerCase()) > -1
        ) {
          return item;
        }

        //Class name
        if (
          item.ClassName.toLowerCase().indexOf(this.SearchQuery.toLowerCase()) >
          -1
        ) {
          return item;
        }

        //student fee
        const fee = item.StudentFee?.toString() || "";
        if (fee.indexOf(this.SearchQuery.toString()) > -1) {
          return item;
        }
      });
    },
  },

  methods: {
    SessionUserIdNo() {
      return this.$API
        .get(this.$LoginUserDetailAdmin, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;

            this.$API
            .get(this.$FindTutorList + "?countryId=" + this.user.countryId, {
              withCredentials: true,
            })
            .then((response) => {
              if (response.status == 200 && response.data != null) {
                this.ftlist = response.data;
              }
            });
          }
        });
    },
    
    OpenFormSubject() {
      this.SubjectModal = true;
    },

    CloseSubject() {
      this.FormSubject = false;
    },

    OpenFormExam() {
      this.ExamModal = true;
    },

    CloseExam() {
      this.FormExam = false;
    },

    AddNewSubject() {
      this.FormNewSubject = true;
    },
    
    // ApplyFilter: function () {
    //   var arr = _.orderBy(this.FilteredSubjects, ["SubjectName"], ["asc"]);
    //   if (_.isEmpty(arr) == false) {
    //     const result = _.filter(arr, ({ SubjectName, Teachers }) =>
    //       _.some([
    //         _.includes(!SubjectName || SubjectName.toLowerCase(), [
    //           this.SearchQuery.toLowerCase(),
    //         ]),
    //       ])
    //     );
    //     this.FilteredSubjects = result;
    //   }
    // },
    // FilteredData() {
    //   console.log("masuk");
    //   this.FilteredSubjects = this.subjects;

    //   if (this.selectedGrade !== "ALL GRADE")
    //     this.FilteredSubjects = _.filter(
    //       this.FilteredSubjects,
    //       (item) => item.Grade === this.selectedGrade
    //     );

    //   if (this.selectedClass !== "ALL CLASS")
    //     this.FilteredSubjects = _.filter(
    //       this.FilteredSubjects,
    //       (item) => item.ClassName === this.selectedClass
    //     );
    // },
    
    // GetFindTutor() {
    //   this.$API
    //     .get(this.$FindTutorList + "?countryId=" + this.user.countryId, {
    //       withCredentials: true,
    //     })
    //     .then((response) => {
    //       if (response.status == 200 && response.data != null) {
    //         this.ftlist = response.data;
    //       }
    //     });
    // },

    GetSubject() {
      this.$API
        .get(this.$ListSubject, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.subjects = response.data;
          }
        });
    },

    SubmitSubject() {
      if (
        this.Name === "" ||
        this.ShortName === "" 
      ) {
        this.Error = true;
        this.Message = "Please Complete the forms";
      } else {
        setTimeout(() => {
          this.SubjectModal = false; // set the SubjectModal value to false to close the modal
        }, 5000);
        this.lblBtn = "Processing";
        this.Error = false;
        const formData = new FormData();

        formData.append("Name", this.this.selectedSubject);
        formData.append("ShortName", this.ShortName);

        return this.$API
          .post(this.$CreateNewSubject, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200) {
              this.lblBtn = "Proceed";
              this.$dialog
                .alert("Success save new subject")
                .then(function () {});
              this.RefreshData();
            } else {
              this.Busy = false;
              this.$dialog
                .alert("Error to create subject ")
                .then(function () {});
            }
          })
          .catch((error) => {
            this.Busy = false;
            this.Loading = false;
            this.Error = true;
            this.Message = error.response.data.message;
          });
      }
    },

    SubmitExam() {
      if (
        this.Name === "" ||
        this.ShortName === "" 
      ) {
        this.Error = true;
        this.Message = "Please Complete the forms";
      } else {
        setTimeout(() => {
          this.ExamModal = false; // set the SubjectModal value to false to close the modal
        }, 5000);
        this.lblBtn = "Processing";
        this.Error = false;
        const formData = new FormData();

        formData.append("Name", this.Name);
        formData.append("ShortName", this.ShortName);

        return this.$API
          .post(this.$CreateNewExam, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200) {
              this.lblBtn = "Proceed";
              this.$dialog
                .alert("Success save new subject")
                .then(function () {});
              this.RefreshData();
            } else {
              this.Busy = false;
              this.$dialog
                .alert("Error to create subject ")
                .then(function () {});
            }
          })
          .catch((error) => {
            this.Busy = false;
            this.Loading = false;
            this.Error = true;
            this.Message = error.response.data.message;
          });
      }
    },

    // OpenDeleteSubject(item) {
    //   // item.SubjectId = item.SubjectId
    //   // this.DeleteSubject = true;

    //   let message = "Are you sure want to delete the subject?";

    //   let options = {
    //     html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
    //     loader: false, // set to true if you want the dailog to show a loader after click on "proceed"
    //     reverse: false, // switch the button positions (left to right, and vise versa)
    //     okText: "Yes, sure.",
    //     cancelText: "Cancel",
    //     animation: "zoom", // Available: "zoom", "bounce", "fade"
    //     type: "basic", // coming soon: 'soft', 'hard'
    //     verification: "continue", // for hard confirm, user will be prompted to type this to enable the proceed button
    //     verificationHelp: 'Type "[+:verification]" below to confirm', // Verification help text. [+:verification] will be matched with 'options.verification' (i.e 'Type "continue" below to confirm')
    //     clicksCount: 3, // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
    //     backdropClose: false, // set to true to close the dialog when clicking outside of the dialog window, i.e. click landing on the mask
    //     customClass: "", // Custom class to be injected into the parent node for the current dialog instance
    //   };

    //   this.$dialog
    //     .confirm(message, options)
    //     .then(async (response) => {
    //       // this.UpdateOfferAppStatus(statusId, index);
    //       await this.DeleteSubjects(item.SubjectId);
    //       //this.EmailOfferAppStatus(identityNo, index);
    //     })
    //     .catch(function () {});
    // },

    // DeleteSubjects(SubjectId) {
    //   const formData = new FormData();

    //   formData.append("Id", SubjectId);

    //   return this.$API
    //     .post(this.$DeleteSubject, formData, {
    //       withCredentials: true,
    //     })
    //     .then((response) => {
    //       this.info = response.data;

    //       if (response.status == 200) {
    //         this.$dialog.alert("Details Subjects Deleted!");
    //         this.RefreshData();
    //       } else console.log("Error Deleting");
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // },

  },
};
</script>